export const SETTINGS_URL_OVERRIDE = 'settings-url-override';
export const DISMISSED_ALERT_IDS = 'dismissed-alert-ids';
export const SUBMIT_CASE_DRAFT_ID = 'submit-case-draft-id';
